import { render, staticRenderFns } from "./GalleryCard.vue?vue&type=template&id=154875bb&"
import script from "./GalleryCard.vue?vue&type=script&lang=js&"
export * from "./GalleryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports